module.exports = __webpack_public_path__ + "media/livevideo.52dd7172.mp4";